var _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGain1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.542969,
    y: 0.626953,
    width: 25.2716,
    height: 25.2716,
    rx: 10.1086,
    fill: "url(#pattern0_907_1771)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_907_1771",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_907_1771",
    transform: "scale(0.025)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_907_1771",
    width: 40,
    height: 40,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAPeSURBVHgBzZlNiBNJGIbfqvSCLCvEZS+7C27GhVnZPUw2M4c9LJjATlgPgnNUcYwH9RhFL55MTp4GM3hSD/Y4qAcPCgrijJAIHjyMISL+IP7EEcaDitHxjzGp8qtqEzKZ7k53iJ08l+r0T+rN+31VXfWFoUNGZlNxgVqUgW+QDFFAhiER1hcZKkyyMh2VJeQtDl6YGzUL6ADm5+Z4PhV+WxVpempvQ4z3nsoMrPBdiGVvJMyy98c8C5OHyKW96AKMMdOr0LYCh6+OpyWQ8e1Y+57LEDJbTE6b7re5EJvdcaRbrjnBwXJzo1P7nK7bClQhXazK85TgcQQA5WapZrBEKWFWWq9xuwcWqyIflDgF9RUNkSF211YIVGGlnIsiYJQhIzqllrMsxLGZ7SkaYifRS2pyX/H/6Vz9Y0PgP/lUZKkm8vRTIugtFWHwgXo+NkL8uUbzXO/FKcKGnnMttIPavap4gj6CXFyjXNQOavf6DL4k9PyrBQY5pXiGI60aZq1KaHAEyKaf/8X+P7bRfPsBxx+dx8Xn12GvkSc4iYsjQJS4zF+7sNr4Hr+s+kkLdUIt5wx6zQxRiNEJw2vW6w4Xqx9xdv4KFj69hBdxzSgXnZCCxQ1qIuiAPes2Y/e6scbnrWuTyNw54RguO3EKFWInWAhDBnkXgU8ODG7DFhLUSl1Aq0gncW4/SENLPHLQ+zpP5c3EUFqH1olWkR2Ls9ACPaES+tjIQd02o3JICbcT2XrsU5yGxWbHX6ONi4M/rMVENL1CnBoUe+YOY/jH9cj8uQte8COOqBhqB+a2nK/PWa0uzb2+jwO3JrWDCwtWh+1E+hSnFrJlg7aHJekyknf/PrZC3Jn5GUw8OL3s3MU2Iv2KUwghn3IJcc3tplZxxx5fWCGuWWTm7gl0Q5yCcZRCv47HVpGDKaebXi29weDq3/Tx4Xsmzj6bcf3SB4vzuPTVzdtvHuHow3MovCiiE+hVl9XLLS8DJXCoMlFMTg3UF6yT6Dc4ClYDvTjMoc8Qn1lWtVqgXv+zPnKRSiOljVZZpLEnESGeoaaCXkO5V3dP0RBo7aJ4Fj2HZevuKZZt3IujZq6noZaYLCZNs/mUbW1meHZHPuh9inqj3UxO/d163rY2Q4WcMVXQQUCowmbtPUvYX3MhdnU8R7an8S3RYT3lWOLjbs8W/6MHJd8Jq97cZRgNSqrDuIhTuApUqKQVNZaQElPoFuSaeMcGiqPTbV8Qvoro0cupCAuJDOXMBsrqCHyhHSNhPFcaMz3Pt74ENvN1wx+ngviQKjpZmy8ZbohRf0XQ9Colu0ZhKnX6N8QXv0uhymNTgZgAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGain1);
export default __webpack_public_path__ + "static/media/gain-1.b633d18f93676e26c60e18caf81477f9.svg";
export { ForwardRef as ReactComponent };